import $ from 'jquery';
import  Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';
const showGrid = (selectedTag = '', searchTerm = '') => {
    const data = {
        action: 'filter_posts',
        ume_nonce: wp_environment.ume_nonce,
        tag: selectedTag,
        search: searchTerm,

    };
    $.post(wp_environment.ume_ajax_url, data, function(response){
        if(response){
            $('.ume-projects-holder').html(response);
           imagesLoaded(document.querySelector('.masonry-grid'), function(instance){
               const msnry = new Masonry('.masonry-grid',{
                   columnWidth: 350,
                   itemSelector: ".grid-item",
                   gutter: 30
               })
           })




            $('.masonry-grid').fadeIn('slow');
            const happening = new Event('showedGrid');
            document.dispatchEvent(happening);
        }
        $('.ume-projects-search').click(function(event){

            if (event.preventDefault) {
                event.preventDefault();
            } else {
                event.returnValue = false;
            }

            let searchTerm = $('.ume-projects-search').prev('input').val();
            $('.masonry-grid').fadeOut('slow');
            showGrid('', searchTerm);



        })
        $('.ume-projects-tag-link').click(function(event){

            if (event.preventDefault) {
                event.preventDefault();
            } else {
                event.returnValue = false;
            }


            let selectedTag = $(this).attr('data-target');
            let level = $('.ume-projects-holder').attr('data-show')
            $('.masonry-grid').fadeOut('slow');
            showGrid(selectedTag);



        })
    })
}
$(document).ready(function(){
    if (document.querySelector('.ume-projects-holder')) {

        showGrid();
    }


})